module.exports = __webpack_public_path__ + "static/media/SMG-web-Category-1.4c43ec65.png";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/mcGee/SMG-web-Category-1.png
// module id = 570
// module chunks = 0